module.exports = __webpack_public_path__ + "static/media/HeroSteakBowl.83e540a8.jpg";